module.exports = __webpack_public_path__ + "static/media/blue-plus.f59130bc.svg";